import { AsyncPipe, DatePipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { finalize, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'sd-countdown',
  templateUrl: './countdown.component.html',
  imports: [NgIf, AsyncPipe, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownComponent implements OnInit {
  @Input() untilTimestamp: number;
  @Output() completed = new EventEmitter<void>();

  countdown$: Observable<Date>;

  get msLeft(): number {
    const diff = this.untilTimestamp - Date.now();

    return diff > 0 ? diff : 0;
  }

  ngOnInit(): void {
    this.countdown$ = timer(0, 1000).pipe(
      takeWhile(() => this.msLeft > 0),
      map(() => new Date(this.msLeft)),
      finalize(() => {
        this.completed.emit();
      }),
    );
  }
}
